import { BulkFieldValue } from '../../../../types'

import type { Texts } from './useTexts'

function isEmpty(value: string) {
  return value.trim().length === 0
}

function matchHHMMFormat(value: string) {
  const regex = /^([0-9]?[0-9]):([0-5]?[0-9])$/gm
  return value.match(regex) !== null
}

function parseSeconds(value: string) {
  if (isEmpty(value)) return 0

  const [hh, mm] = value.split(':')
  const hours = parseInt(hh)
  const minutes = parseInt(mm)

  // invalid format not handled here
  if (isNaN(hours) || isNaN(minutes)) {
    return -1
  }

  return hours * 3600 + minutes * 60
}

// 23:59
const maxValue = 23 * 3600 + 59 * 60

export const createValidateServiceTime = (texts: Texts, serviceTimeSec: BulkFieldValue<string>) => {
  if (serviceTimeSec) {
    const hasValidFormatError = {
      id: 'hasValidFormatError',
      field: 'serviceTimeSec',
      message: texts.invalidServiceTimeFormat,
    }

    const exceededMaxCountError = {
      id: 'exceededMaxCountError',
      field: 'serviceTimeSec',
      message: texts.invalidServiceTimeMaxValue,
    }

    const hasValidFormat =
      serviceTimeSec.status === 'exact'
        ? isEmpty(serviceTimeSec.value) || matchHHMMFormat(serviceTimeSec.value)
        : true

    const exceededMaxCount =
      serviceTimeSec.status === 'exact' && hasValidFormat
        ? parseSeconds(serviceTimeSec.value) > maxValue
        : false

    return {
      [hasValidFormatError.id]: !hasValidFormat ? hasValidFormatError : undefined,
      [exceededMaxCountError.id]: exceededMaxCount ? exceededMaxCountError : undefined,
    }
  }
}
